module.exports = __webpack_public_path__ + "img/outwear.1f0c88f2.svg";